import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import React, { Component } from "react"

/**
 * shop - магазин.
 * onEditShopClick(shop) - запрос на редактирование магазина.
 * onCancelClick() - запрос отмены добавления магазина.
 */

class EditShopDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            name: "",
            dialog: undefined,
        }

    }

    componentDidMount() {
        if (this.props.shop) {
            this.setState({
                name: this.props["shop"]["name"],
            })
        }
    }

    readyToEdit() {
        if (this.state.name === this.props["shop"]["name"]) {
            return false
        }
        if (this.state.name === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Редактировать магазин
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.name}
					label = "Название магазина"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({name: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.readyToEdit()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onEditShopClick === "function") {
                            this.props.onEditShopClick({
                                name: this.state.name,
                            })
                        }
                    }}
                >Сохранить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default EditShopDialog